module.exports = __webpack_public_path__ + "b249ea253cf1cb516525cc2d2326f4c3.svg";